module.exports = {
	"imgNavPic": require("@/assets/data/img/support-article/support_menu_title.png"),
	"aNavMenu": {
		"/support/1": {
			"name": "产品文档",
			"child": {
				"/support/1_1": {
					"name": "物联网链接器",
					"icon": "iconfont icon-wulianwanglianjieqi",
					"imgHead": require("@/assets/data/img/support-article/物联网链接器.png"),
					"content": [{
						"name": "物联网链接器",
						"text": [
							"暂无信息"
						]
					}]
				},
				"/support/1_2": {
					"name": "Qiot物联网软件",
					"icon": "iconfont icon-QiotPro",
					"imgHead": require("@/assets/data/img/support-article/Qiot物联网软件.png"),
					"content": [{
						"name": "Qiot物联网软件",
						"text": [
							"暂无信息"
						]
					}]
				},
				"/support/1_3": {
					"name": "QLINK物联网模块",
					"icon": "iconfont icon-Qiotmokuai",
					"imgHead": require("@/assets/data/img/support-article/物联网链接器.png"),
					"content": [{
						"name": "QLINK物联网模块",
						"text": [
							"暂无信息"
						]
					}]
				},
			}
		},
		"/support/2": {
			"name": "APP使用说明",
			"child": {
				"/support/2_1": {
					"name": "Qiot Pro",
					"icon": "iconfont icon-QiotPro",
					"isList":true,
					"imgHead": require("@/assets/data/img/support-article/Qiot使用说明.png"),
					"content": [{
						"name": "功能特点",
						"child":[
							{
								"name":"特色功能",
								"text":[
									"1、开发模式设备：添加开发模式的设备，可自由选择设备类型，或者通过调试模式生成自定义界面；",
									"2、调试模式：与硬件进行双向控制解析，可将硬件收发的报文设置成UI控制界面；",
									"3、生成界面：将硬件收发的报文设置为开关或数据变量，自定义UI控制界面；",
									"4、采集设置：适用于不能主动请求数据的硬件，自定义设置请求报文及请求频率；",
									"5、存为产品：将已创建完UI控制界面的开发模式的设备保存为产品模板，可在产品列表管理该产品的系列号及其用户；",
									"6、产品管理：管理产品的系列号使用，并可查看用户使用信息。"
								]
							},
							{
								"name":"功能特点",
								"text":[
									"1、轻量级快消品型智能家居APP的简单操作特点：扫描二维码添加硬件立即使用（如：JD超级APP，阿里小智、小米智能APP等。）；",
									"2、实现市场上主流的工程级智能家居系统特性，以及各种未知和各方硬件的复杂配置；",
									"3、APP具备产品管理，用户管理等功能；",
									"4、具备硬件智能化生产的条件；",
									"5、开发，分发一体解决方案；",
									"6、可视化开发，迅速快捷。"
								]
							}
						]
					},{
						"name": "适用人群",
						"child":[
							{
								"name":"适用人群",
								"text":[
									"Qiot Pro 适合中小型智能硬件品牌商、智能家居工程商、极客&爱好者。"
								]
							},
							{
								"name":"基础能力",
								"text":[
									"使用者必须具备一定的基础能力。如下：",
									"1、熟悉以太网TCP/IP，IP地址等；",
									"2、熟悉基本硬件知识，硬件串口，485总线、通讯报文等；",
									"3、有一定的硬件连接动手能力。",
									"如果不具备任何上述能力，请自行补习。"
								]
							},
							{
								"name":"常见应用",
								"text":[
									"1、硬件双向控制解析；",
									"2、管理智能硬件。"
								]
							}
						]
					},{
						"name": "操作指南",
						"text":[
							"建议查看Qiot Pro APP操作指南时结合手机实际操作，能够更好地帮助您快速上手。APP整体结构清晰明了，主界面显示设备控制、场景控制、定时任务三大块，也是核心的三大控制功能；左侧菜单可查看个人资料、系统消息、设置、用户列表、产品列表。"
						],
						"child":[
							{
								"name":"登录注册",
								"text":[
									"<b>[注册]</b>新用户注册时如果有邀请码则输入“@邀请码”，没有可以放空。使用邀请码注册的用户，将获得被邀请用户的所有设备控制权限。",
									"<b>[登陆]</b>使用已注册的账号登陆，输入手机账号及密码登陆。",
									"<b>[忘记密码]</b>通过手机短信验证码直接更改新密码。",
								]
							},
							{
								"name":"添加设备",
								"text":[
									"注册时如果有邀请码则输入邀请码，没有可以放空。",
									"添加设备请点击右上角“+”进入添加页面,提供4种添加类型，类型不同创建的设备也有区别，可通过以下方法添加智能硬件：",
									"<b>[二维码扫描]</b>通过服务商得到智能硬件，扫描二维码后即可添加并绑定该设备。开启智能硬件并链接上网络，只需扫描智能硬件上的序列号二维码即可添加该硬件；",
									"<b>[系列号输入]</b>手动输入系列号添加智能硬件。添加的设备类型与二维码扫描一致，我们统称为智能产品；",
									"<b>[自定义]</b>通过模板生成空白设备，并配置设备控制命令。（单向，没有反馈）提供常见遥控器和继电器模板，可生成常见的控制器，生成后必须逐个设置按键发送的命令；",
									"<a href='/#/404'>查看APP使用步骤图</a>",
									"<b>[开发模式]</b>本系统特色功能之一,根据任意协议报文生成开关（设备操作）&数据变量（反馈界面）；点击该图标即可生成空白界面，初始化界面为空白无控件，在设备列表页面左滑开发模式的设备选择“调试模式”功能设置报文添加开关按键、指示灯、仪表等控件的功能。",
									"<a href='/#/404'>查看APP使用步骤图</a>"
								]
							},
							{
								"name":"设备功能菜单",
								"text":[
									"通过扫一扫与系列号添加的设备都能直接控制，通过自定义与开发模式添加的设备则需要绑定QLINK的智能硬件配对WiFi后才可控制设备，需要在设备的功能菜单中操作。",
									"<b>功能菜单</b>：对该设备进行除页面控制命令外的其他功能操作。</b>",
									"当创建完设备后，进入到设备页。点击右上角的 “...”弹出操作菜单，根据不同的设备类型，菜单操作的功能也有差异。",
									"通过二维码扫描与系列号输入添加的智能产品可进行重命名、设备信息、WiFi配对的操作；",
									"通过自定义与开发模式添加的设备可进行重命名、设备信息、绑定设备、WiFi配对、学习模式、添加控件、采集设置、存为产品的操作。",
									"以下介绍更多菜单中的所有功能操作：",
									"<b>[重命名]</b>重新更改该设备的名称。",
									"<b>[设备信息]</b>查看该设备的详细信息，主要为2大块内容，从上往下依次为设备信息、命令信息。",
									"设备信息主要显示该设备的基本信息，含设备名称、设备类型、设备号、设备号类型、目标服务器、方式、端口。其中，目标服务器、方式、端口是重要链接信息，用于绑定设备。若添加设备为自定义或开发模式类型的设备，则必须自行链接互联网，链接该设备信息指向的目标地址，并上报序列号，上报后将建立通道，当该设备显示“在线”状态时表示可以正常使用。链接互联网时可通过PC版的“网络助手”软件来测试链接的情况，若觉得自行链接互联网复杂繁琐可以通过购买QLINK的物联网连接器或者物联网模块来快速实现与设备链接，无需设置，接入设备即可使用。立即购买 物联网链接器 物联网模块",
									"命令信息显示了所有按钮的控制命令。命令信息后缀的“（H）”与“（C）”是区分命令格式的标示，“（H）”表示该报文命令是 16进制命令，“（C）”则表示该报文命令是字符串命令。",
									"<b>[绑定设备]</b>绑定QLINK的物联网链接器或其他设备时使用。",
									"自定义与开发模式添加的设备，添加后是未绑定未配置的空设备暂时无法控制。可以自行购买以太网模块来实现互联网链接，或者购买QLINK物联网链接器轻松实现设备互联网链接，无需经过复杂设置调试，绑定时只需扫描QLINK连接器上的二维码，即插即用，方便快捷。",
									"<b>[WiFi配对]连接当前环境下的WiFi网络，当用户更换WiFi环境时则需要重新配对WiFi来链接互联网。",
									"如果绑定的设备是QLINK WiFi 模块,在绑定后会自动跳出WiFi配对功能完成配对，但是更换路由，或者更换设备地点就要经过此功能重新将WiFi模块和路由器配对链接。",
									"<b>[学习模式]</b>学习模式下，可以学习新的控制命令，旧命令将被覆盖。 ",
									"<a href='/#/404'>查看APP使用步骤图</a>",
									"自定义与开发模式添加的设备才有学习模式，进入学习模式后，原来的控制模式转化为学习模式，此时点击任意按键将跳出学习对话框，表示重新学习该按键命令。学习命令的对话框默认等待30秒，学习监听来自于硬件的报文，一旦接收到来自于硬件的报文会自动显示在该对话框中。然后点击“完成”旧命令将被本次监听的报文覆盖。",
									"学习命令功能可通过PC的网络助手上报控制报文，可以迅速地完成设置。除此之外，也可选择“手动配置”手动输入控制报文来完成设置。手动输入的报文默认为16进制，此时若点击右侧的（字符串）按钮则切换成字符串类型的报文输入。 ",
									"学习模式是单个按钮单次学习的，当学习成功或者点击取消时将恢复到正常控制模式。",
									"<b>[添加控件]</b>特色功能之一，仅开发模式类型的设备才可设置，自定义添加数据变量或开关。",
									"<a href='/#/404'>查看APP使用步骤图</a>",
									"添加控件功能需要配合QLINK物联网链接器使用，通过链接器监听设备发送的报文，将报文自定义为关键字、开关或数据变量控件，直接生成针对该智能硬件的控制界面，轻松完成轻量级的软件开发。",
									"具体操作如下：",
									"首先确保QLINK物联网链接器与智能硬件连接成功，点击添加控件进入调试模式，长按硬件发送的报文选择“生成界面”，",
									"<b>[采集设置]</b>特色功能之一，仅开发模式类型的设备才可设置，设置采集报文循环发送的时间。",
									"<a href='/#/404'>查看APP使用步骤图</a>",
									"采集设置是编辑采集频率并输入要发送的报文完成采集报文，点击添加后完成一条设置，添加成功的采集报文会显示在采集报文列表下方，可自由添加多条采集报文，也可向左滑动删除某条采集报文，设置完成后手机会自动设置的时间周期循环按报文列表的顺序逐个发送。",
									"采集设置的特色功能是让手机能根据指定的时间段来读取目标设备实时的状态，自定义报文按设定周期循环发送查询请求，得到后返回，可循环地刷新页面实时显示内容。特别对于无法主动发送状态的硬件，就可使用该功能来实现数据主动查询，使用非常实用便利。",
									"<b>[存为产品]</b>特色功能之一，仅开发模式类型的设备才可设置，将界面另存为产品供其他用户使用。",
									"<a href='/#/404'>查看APP使用步骤图</a>",
									"存为产品式直接将当前设备定义的界面保存为软件产品，它帮助了硬件工程商、软硬件从业者、硬件专家等在Qiot Pro 上就能够为自己的硬件定制化生成控制界面，不需要开发软件，而且不是独自使用，还可授权给其他用户使用，可以用于经营，销售，分享。",
									"目前，市场上常见的智能数码产品，都是批量生产，客户购买到产品后可以轻松使用软件来控制，简单到只需APP扫描二维码即可在APP上控制该硬件。而这些系统级的应用往往依赖于复杂的后台管理系统来实现。而要实现这样的功能是需要很多工作和时间的，大概流程为：开发->调试->软硬件联调->软件二次开发适配->库存管理->二维码生成->二维码绑定管理->二维码产品绑定->发放->鉴权->用户绑定->后台用户管理->后台设备管理->用户设备绑定关系管理。而后台管理系统按子系统又细分为：进销存系统、产品管系统、用户管理系统、智能配置系统等，整个流程中，在产品未销售前就需要经历很多的流程，大把的时间和金钱花在了产品开发上，而影响了产品后期销售利润及用户体验。所以，若自己完成一个智能产品的开发需要花费漫长的时间和巨大的人力物力。",
									"存为产品的功能是为实现上述功能而设计的，用户只需在Qiot Pro上简单操作如下步骤即可让产品直接卖给客户后通过软件扫描系列号二维码就能体验智能控制，让厂商能够把精力和重心放在宣传销售、用户体验与售后服务上。我们将流程不仅是简化，更是拉近了厂商与顾客之间的距离，整个流程如下：",
									"使用Qiot Pro创建开发模式设备->存为产品，保存已设置的设备->命名，生成产品型号->后台批量生成副本和对应系列号二维码（即产品仓库，可在手机端和PC端同步管理产品及用户） ->将序列号写入MCU，并将链接目标指向指定服务器；或者通过购买QLINK物联网链接模块无需设置直接与智能硬件连接->发放邀请码给用户，用户下载注册APP->用户购买该产品->扫描产品上的二维码获得该产品的控制APP",
									"不只是简化流程，是简单到只需点击“保存”即可完成产品软件开发及后台管理系统的开发，而且保存的产品会在主菜单的“产品列表”里，用户可在手机端管理产品及其用户。",
								]
							},
							{
								"name":"设备控制",
								"text":[
									"在设备控制栏中显示了所有成功添加的设备，含二维码扫描或系列号输入添加的智能硬件、自定义添加的设备，以及开发模式生成的设备界面。",
									"<b>[设备控制]</b>根据创建设备的类型控制其智能硬件，与智能硬件进行远程交互控制。",
									"<b>[调试模式]</b>特色功能之一，此功能对于智能硬件开发的意义重大，方便调通智能硬件控制。",
									"在设备控制列表中，左滑自定义或开发模式类型的设备，显示“调试”和“删除”操作。",
									"调试模式：是手机端与该设备进行数据双向通讯。其特点是：",
									"1、 直接测试APP 某按键的控制命令是否有效；",
									"2、 使用PC端网络助手，通过PC传来命令，可直接将其复制进入学习模式后使用“手动配置”粘贴命令后即可设置成该按钮的控制命令，使用便捷，不需要手动输入命令，高效完成设置；",
									"3、 直接获取来自智能硬件发送的报文；",
									"4、 监听手机端与硬件端的通讯报文；",
									"5、 将报文生成设备控制界面。",
									"删除：即删除当前设备。",
									"其中，最为特殊的是“调试”功能，通过QLINK物联网链接器，使手机端与硬件端可以自由发送任意内容互相通讯。调试操作类似常见的即时聊天对话的软件一样，左边为硬件端，右边为手机端，格式如某信，下方为报文发送的输入框，手机端与硬件端就像聊天一样通讯，并保存即时通讯的消息内容，而且通讯的报文以及发送报文还可进行更多操作。",
									"通讯报文的操作：长按任意报文可对该报文进行复制、生成界面的功能，通讯报文显示还可切换字符类型模式。复制该报文，可黏贴至发送框内；生成界面可将报文的某段字节定义为关键字、开关、数据，保存后将生成针对该设备而定制的控制界面；顶部的16进制与字符串的按钮可切换整个对话框的字符类型，默认显示为16进制模式。",
									"<a href='/#/404'>查看APP使用步骤图</a>",
									"发送报文的操作：点击发送框右侧的“+”显示循环发送与清除的操作，用户使用“循环发送”功能可以指定时间段内让报文执行循环发送至设备端，使用“清除”功能可清除对话框内的所有通讯记录。",
									"<a href='/#/404'>查看APP使用步骤图</a>",
									"生成功能为开发模式的设备独有，用于定义协议解析规则。生成对应的UI界面，用户则不需要自己开发软件，使用Qiot Pro 简单操作就能极速的生成适应于该设备的控制界面。"
								]
							},
							{
								"name":"场景控制",
								"text":[
									"场景控制是在现有可控设备的基础上，组合由单个或多个设备的多个控制命令为一键控制的操作。用户设定发送的控制命令以列表显示，可对每个控制命令设定执行的时间间隔。当点击场景开关时，将会按场景列表的顺序，并且根据每条控制命令的时间间隔逐个发送设定的控制命令。",
									"<a href='/#/404'>查看APP使用步骤图</a><a href='/#/404'>查看范例</a>",
									"添加场景操作简单，类似电商购物时添加到购物车方法一样。首先点击场景控制栏中右上角的“+”添加场景，显示当前已经创建成功的所有设备（与设备控制栏中显示的设备一致）；",
									"然后点击某个设备进入控制界面，选择某个按键命令，则会跳出对话框提示已经添加了该动作，是否继续添加场景动作，可选择“完成”结束场景命令编辑，或者选择“继续添加”可重复选择该设备的其他控制命令或者选择其他设备的控制命令；",
									"场景编辑过程中，可对列表中的所有控制命令随时更改时间间隔及删除操作。场景控制命令默认的时间间隔为2秒，可点击控制命令进行更改时间间隔，向左滑可对该控制命令进行删除操作，控制命令右侧的“三”号,可以自由拖动该控制命令进行上下移动排列顺序；",
									"点击完成后需给场景命令，保存场景结束本次场景的添加，完成一个场景创建，用户使用时只需点击该场景的“执行”按钮就可以实现一键轻松完成多个控制命令的操作。创建完成的场景在场景控制栏中以列表展示，除了“执行”操作还可向左滑对其进行删除或点击场景进行再次编辑。点击场景可查看该场景的控制命令列表，在右上角可点击“编辑”操作，可继续添加新控制命令、排序、删除的操作，操作与添加时一致。",
									"点击场景“执行”进行一键场景控制，执行成功时不会有任何提示，而失败时会有执行失败的提示。",
									"场景控制能够让用户生活中用电习惯以及重复操作的步骤简化成一键控制，高效优化了控制体验，也给用户生活带来便利及其良好用电习惯的养成。"
								]
							},
							{
								"name":"定时任务",
								"text":[
									"定时任务是以设备的某个控制命令或某个场景为对象，设置某个时间点及循环周期，使其在某时间点可循环地执行控制的任务。",
									"<a href='/#/404'>查看APP使用步骤图</a><a href='/#/404'>查看范例</a>",
									"在定时任务栏中，在上方可切换设备定时与场景定时任务，若在设备定时任务页面中去点击右上角“+”创建的定时任务为设备定时任务，若在场景定时任务页面中去点击右上角“+”创建的定时任务则为场景定时任务。点击添加后进行选择定时任务的对象，设备定时选择的是某个按键控制，场景定时则选择某个场景即可；下一步进行定时设置，设定执行的时间点，设置执行的次数与重复规律，并设置执行时是否推送消息；最后保存命名即可完成定时任务创建。"
								]
							},
							{
								"name":"个人中心",
								"text":[
									"在左侧菜单中可以查看到用户的账号信息，点击进入个人中心，可查看到更多用户的信息。",
									"<b>[个人资料]</b>显示用户的注册的账号信息，以及头像、昵称、ID、手机号、邮箱、性别资料。除账号信息外，其余信息可以更改。",
									"<b>[我的家人]</b>类似与分享功能，可将自有的所有设备控制权限分享给他人使用，一样可以执行所有设备控制。 ",
									"<a href='/#/404'>查看APP使用步骤图</a>",
									"用户在个人中心页面可查看到邀请码，记住邀请码告知需要分享的用户，让其注册时填入“@邀请码”注册账号，受邀的用户将显示在邀请人的“我的家人”列表中，长按对象可对家人成员进行删除。",
									"<b>[信息中心]</b>系统推送的消息内容，可自由删除。 ",
									"<b>[反馈]</b>可编辑意见或建议发送给我们，支持我们更好的改良用户体验及交互。 "
								]
							},
							{
								"name":"产品管理",
								"text":[
									"特色功能之一， 产品列表页显示所有 “开发模式”和“空设备”类型设备可以使用“存为产品”的功能将控制界面存为产品模板，产品列表页则显示所有产品模板 。",
									"<a href='/#/404'>查看APP使用步骤图</a>",
									"有了产品模板就可复制创建无数产品副本，产品包含链接服务器的序列号凭据。可将序列号或者二维码写入智能硬件用于回复服务器鉴权，并将二维码贴在智能硬件上即可销售。用户购买到手使用Qiot Pro直接扫描二维码即可添加该产品副本，并且和模板设备毫无冲突，可自由控制该智能硬件。（貌似信息量很大？画个草图） ",
									"从产品开发的角度可以理解为：产品模板即为产品原型，通过此原型复制（量产）出副本，给用户，自己直接使用，而无需再经历第一次创建时费脑的协议解析设置，简单到用APP扫描生成的二维码即可使用，并完成服务器的鉴权和自动设置好用户设备的绑定关系。 ",
									"从行业工程应用角度可理解为：面对工程方案多样化的部署，按传统的硬件、协议、用户、配置、绑定等同时需要创建无数表格、纸质、协议库列表等来管理，难以管理和交接，而模板化解决了这些问题。编写过的硬件通过该功能，管理硬件，可重复使用，用户自行绑定，关联关系一目了然。",
									"导航==》如何绑定，见用户列表。 ",
									"产品列表，左拉产品项的详细信息可显示保存的产品信息和协议设定规则。 Qiot Pro之所以能适配所有硬件，生成产品，是因为可对任意协议进行解析规则设定。 原理：通过设定报文的 报头关键字、开关标记位、量值等参数生成可读的UI界面；再通过界面生成的控件，设定控件发送的控制字；并保存为产品模板，用于批量生产。 解释如下： 产品名称由调试时生成的时候输入，有利于记住设定的协议规则。 条形码即为系统生成的产品唯一码。用于快速找到该产品。 采样间隔设置： 通常，获得设备状态当前状态有两大方法。 常见的大多数简单传感器都是有周期性的上报当前传感器值，该值会自动传送于手机，通过设定可以解析为明文；所有无需去做采样设置； 对于功能多样化的高级设备，经常需要按需去发送查询指令获得反馈值，如：查询目标设备开关状态、发送开关查询指令，查询水位值发送水位查询指令等。 如果手动去发送这些值，难免繁琐啰嗦。所以，Qiot Pro设定为周期性的循环发送查询指令，让目标设备返回当前所查询的值以被解析。 例如界面实例： 能见三条，意思为，进入设备后手机默认发送 第一条“aaccbb”，停留“1S”后，接着发送“bbccdd”，停留2S后，继续发送“112233”，停留“3S”后，回头继续发送第一条“aaccbb”，停留1S，继续往下发送；如此循环。 但设定的查询正确，设备将应答查询命令，通过下列获得解析：如下： 原始代码： 用户通过手动或者截获下位机传上来的协议原文。 通过设定该报文来设定手机的解析规则，同时生成界面。 下方稍大字体即为设定过的解析规则； 点击每个段落，下方将切换显示该段落设定的规则。 如实例设定的规则是： 1122：报文的关键字是1122，切该关键字位于报文的 1、2字节处（*注），如果传上来的报文符合关键字定义且位于 1、2字节处，那么该报文将被解析，后续解析规则成立；否则忽略该报文。 33：该段落被忽略； 99 F8：该报文已设定为“开关”，位于 4、5字节处，大端表达，有效位数为9位。 详解：大多数智能硬件用 二进制来表达硬件的各种开关的工作状态。例如，空调的各种状态：开着还是关着，制冷还是制热，摆风是否打开，是否打开除湿等等；空调上通常有指示灯来显示这些状态，但显示到手机呢，是通过二进制，其二进制为 0或者1来表达，很直观，0就是关，1就是开； 将此报文定义了2个字节开关作为表达，最多可以表达 16个开关，通常用不了那么多；所有，上述有个“有效位”来描述开关用了16个中的几个以便显示出来；上述 99 F8用Windows计算器可计算出二进制结果(如图)：?1001100111111000?，那么16个开关状态有了 手机会将这16个开关显示出来，但是显示是从左到右显示还是从右到左，此时大小端状态生效（或称高低位在前在后）；再者16个开关是上限，有些硬件用不了那么多，所以就有了有效位，系统将忽略掉有效位以外内容。 E0 CF:该报文设定为“变量”，变量名为UI显示的名称，大端表示，数值从左边读到右边，上下限意显示在界面上该值的范围，如 1-100；比例100；单位为“升”；左边为该项的显示样式； 他产生一个 仪表盘，刻度范围是 1-100；显示在仪表上的指针为；该真实值16进制转化为10进制后除以100得出的结果。E0 CF用大端表达，从左边读到右边，计算器计算后结果57551；除以100得出，575.51。但是仪表盘设置的范围为1-100；所以超出范围而出现呈现红色爆表状态。 其他以此类推，可设置多个。 删除即可删除该产品，并且连同产品下的序列号也全部删除，包括已绑定的产品。 点击“》”可进入该产品下的序列号列表，如没有序列号，或者都已绑定，可点击右上角“+”添加序列号。 每个栏显示了产品副本的基本信息，如：序列号、创建时间、是否绑定等。上方标签可切换绑定表和未绑定表。如已绑定，将显示绑定用户的账号。序列号可通过网站 http://qlink.cc 登陆后导出，可打印标签。 点击序列号可进入查看产品副本详情，图； 分发序列号给用户注册可以截屏，将此页面通过其他聊天工具发送给对方，对方可轻易绑定。如已绑定，右上角可查看绑定的用户，也可解除该用户的绑定。 左拉动序列号栏可删除序列号。"
								]
							},
							{
								"name":"用户列表",
								"text":[
									"对于硬件开发者、小微型硬件企业、智能家居从业人员；往往会出现批量出货等需求；Qiot Pro也满足这些需求；Qiot Pro同时也是一套小型发布系统，可用于管理用户&产品。 方法为：发放邀请码，让用户注册，用户注册后即出现在用户列表。可管理用户，产品和产品用户的绑定关系。 如图：在 十三节的个人中心，点击用户头像可见“邀请码”，将此号码发放给用户，用户注册后即可显示在用户列表。具体为：注册的时候邀请码框输入 “#邀请码” 如图：左拉动用户栏可见操作：分别是“删除”和“列出产品“；其中删除即删除这个用户；列出产品了列出出售后，用户绑定的产品。 点击可进入查看基本用户情况。",
								]
							}
						]
					}]
				},
				"/support/2_2": {
					"name": "必加锁",
					"icon": "iconfont icon-bijiasuo",
					"imgHead": require("@/assets/data/img/support-article/必加锁使用说明.png"),
					"content": [{
						"name": "必加锁",
						"text": [
							"暂无信息"
						]
					}]
				},
				"/support/2_3": {
					"name": "闪钥",
					"icon": "iconfont icon-shanyue",
					"imgHead": require("@/assets/data/img/support-article/闪钥使用说明.png"),
					"content": [{
						"name": "闪钥",
						"text": [
							"暂无信息"
						]
					}]
				},
			}
		},
		"/support/3": {
			"name": "APP下载",
			"child": {
				"/support/3_1": {
					"name": "Qiot Pro",
					"icon": "iconfont icon-QiotPro",
					"imgHead": require("@/assets/data/img/support-article/Qiot使用说明.png"),
					"content": [{
						"name": "Qiot Pro物联网控制软件 ",
						"text": [
							require("@/assets/data/img/qiot_logo.png"),
							"",
							"QIOT Pro意为快速连接，快速物连。QIOT 品牌全称是QLink Control System.就是快控制系统，快联控制器。本App即为控制端，用手机控制一切电器",
							"QIOT Pro为智能家居、自动化控制提供一套绝对简单的控制方法。无需任何技术基础，无需任何编程，QIOT甚至可以无需购买任何产品即可控制电器！你只需在PC端输入被控设备的控制指令；手机即生成控制按键。当然，购买QLink硬件产品的话，PC端配置都可省略。",
							"QIOT Pro面向：",
							"*系统集成工程商——通过QIOT Pro，你们大可不必购买昂贵中控品牌。有了QIOT Pro，你们甚至可以不用中控。也用不着培训；没有门槛。",
							"*电子产品商——通过QIOT Pro，你们的产品可以拥有手机控制端！甚至“QIOT Pro”都改成你们的品牌；不用做项目。马上可实现。",
							"*硬件通讯开发者——通过QIOT Pro，你们可以不必再写App。填入指令即可随心所测（控）",
							"*玩具业——让所有玩具都变成手机控吧",
							"*爱好者——可以把你所有电器、电子产品整成手机控制。",
							"使用微信扫描时，点击右上角“···”，使用浏览器打开进行下载。",
							require("@/assets/data/img/qiot_erweima.png")							
						]
					}]
				},
				"/support/3_2": {
					"name": "必加锁",
					"icon": "iconfont icon-bijiasuo",
					"imgHead": require("@/assets/data/img/support-article/必加锁使用说明.png"),
					"content": [{
						"name": "必加锁  ",
						"text": [
							"必加锁App是一款新型的环境友好型锁，可通过手机二维码扫描直接实现开锁，无卡无钥匙。使开锁方式简单快捷。",
							"必加锁APP可管理多把锁、一把锁可分发多把钥匙。应用非常广泛！多功能移动前台，便捷酒店管理；出租房管理，随时随地轻松搞定；简单实现员工考勤；家里熊孩子什么时间回家的，在外出差的父母也能真实掌握...",
							"科技从未停止它改变世界的脚步，二维码时代的到来是一场新的革命，它将开启我们新的生活方式。必加锁App，操作简单、便捷随意、安全，让我们开启一段属于大家的便捷旅程吧。",
							require("@/assets/data/img/bijiasuo_erweima.png"),
							
						]
					}]
				},
				"/support/3_3": {
					"name": "闪钥",
					"icon": "iconfont icon-shanyue",
					"imgHead": require("@/assets/data/img/support-article/闪钥使用说明.png"),
					"content": [{
						"name": "闪钥   ",
						"text": [
							require("@/assets/data/img/shanyao_logo.png"),
							"",
							"闪钥app是一款扫描二维码就能实现开锁甚至远程遥控开锁的新概念产品。",
							"通过调用手机照相功能，闪钥将快速而精确地扫描识别二维码所对应锁的信息，实现智能开锁。",
							"将你的手机变成一把专业的多功能钥匙，从根本上解决忘带钥匙的烦恼，即使远隔千里也能实现在家招待客人的愿望，真正地实现智能化生活。",
							"闪钥app,一款将你们开启人生明亮之门的app。它将会是你们不可或缺生活贴心小帮手！",
							require("@/assets/data/img/shanyao_erweima.png"),
							
						]
					}]
				},
			}
		},

	}
}


// WEBPACK FOOTER //
// ./src/assets/data/support-article.js